export const copyNewFileToProjectFolder = async (_, __, file, ___) => file

export const cleanTempFiles = async () => undefined
